import axios from "axios";

// Constante pour stocker la clé de l'API Google Translate
const googleTranslateApiKey = "AIzaSyC3XycRahmXPHzfWZikFEwLiKzkNmTAD9I"; // Remplacez par votre clé API Google Translate
export const valueLangSelect = "selectedLanguage"; // Nom de la clé pour stocker la langue sélectionnée dans sessionStorage

// Fonction pour traduire le texte via l'API Google Translate
async function translateText(text, targetLanguage = 'en', sourceLanguage = 'fr') {

    if (sourceLanguage === targetLanguage) {
        return text; // Retourne le texte original si les langues source et cible sont identiques
    }

    const apiUrl = `https://translation.googleapis.com/language/translate/v2?key=${googleTranslateApiKey}`;
    const body = {
        q: text, // Texte à traduire
        target: targetLanguage, // Langue cible
        source: sourceLanguage, // Langue source
    };

    try {
        // Envoi de la requête à l'API Google Translate
        const response = await axios.post(apiUrl, body, {
            headers: {
                'Content-Type': 'application/json',
            },
        });

        // Traitement de la réponse
        if (response.status === 200) {
            const translatedText = response.data.data.translations[0].translatedText;
            return translatedText; // Retourne le texte traduit
        } else {
            console.error(`Erreur API (${response.status}):`, response.statusText);
            return text; // Retourne le texte original en cas d'erreur
        }
    } catch (error) {
        console.error('Erreur lors de la traduction:', error);
        return text; // Retourne le texte original en cas d'erreur
    }
}

// Fonction pour changer la langue
export function changeLanguage(lang) {
    // Stocker la langue sélectionnée dans sessionStorage
    sessionStorage.setItem(valueLangSelect, lang);
    // Mettre à jour la visibilité et l'affichage des drapeaux
    const flags = {
        fr: document.getElementById('frFlag'),
        en: document.getElementById('enFlag'),
        es: document.getElementById('esFlag'),
        de: document.getElementById('deFlag'),
        ar: document.getElementById('arFlag'),
        zh: document.getElementById('zhFlag'),
        ja: document.getElementById('jaFlag'),
        pt: document.getElementById('ptFlag'),
        it: document.getElementById('itFlag')
    };

    // Masquer tous les drapeaux
    for (let key in flags) {
        if (flags[key]) {
            flags[key].style.visibility = 'hidden';
            flags[key].style.display = 'none';
        }
    }

    // Afficher uniquement le drapeau correspondant
    if (flags[lang]) {
        flags[lang].style.visibility = 'visible';
        flags[lang].style.display = 'block';
    }

    // Traduire le contenu de la page
    translatePageContent(lang);
}

// Fonction pour traduire dynamiquement les éléments de la page
async function translatePageContent(lang) {
    const elementsToTranslate = document.querySelectorAll('.translatable'); // Sélection des éléments à traduire

    for (const element of elementsToTranslate) {
        // Déterminer si l'élément a un placeholder ou un texte
        const isPlaceholder = element.hasAttribute('placeholder');
        let originalText;

        if (isPlaceholder) {
            // Pour les placeholders
            originalText = element.getAttribute('data-original-text') || element.getAttribute('placeholder');
            if (!originalText) continue; // Si aucun texte n'est disponible, passer cet élément
            if (!element.hasAttribute('data-original-text')) {
                element.setAttribute('data-original-text', originalText); // Stocker le texte original
            }
        } else {
            // Pour les textes internes
            originalText = element.getAttribute('data-original-text') || element.innerText?.trim();
            if (!originalText) continue; // Si aucun texte n'est disponible, passer cet élément
            if (!element.hasAttribute('data-original-text')) {
                element.setAttribute('data-original-text', originalText); // Stocker le texte original
            }
        }

        // Traduire le texte si nécessaire
        if (originalText && originalText.trim() !== "") {
            try {
                const translatedText = await translateText(originalText, lang, "fr");
                if (isPlaceholder) {
                    element.setAttribute('placeholder', translatedText); // Mise à jour du placeholder
                } else {
                    element.innerText = translatedText; // Mise à jour du texte interne
                }
            } catch (error) {
                console.error(`Erreur lors de la traduction de "${originalText}":`, error);
            }
        }
    }
}

// Appliquer la langue au chargement de la page
document.addEventListener('DOMContentLoaded', () => {
    const savedLang = sessionStorage.getItem(valueLangSelect) || 'fr'; // Langue par défaut : français
    changeLanguage(savedLang); // Appliquer la langue au chargement
});